import { useRef } from "react";
import "pages/Dashboard/TipOfTheDay.scss";
import { ReactComponent as Icon } from "assets/images/icons/icon-light-bulb.svg";
import { ReactComponent as Arrow } from "assets/images/icons/arrow-right-short.svg";
import 'swiper/css';
import useViewData from "features/view/hooks/useViewData";
import Loader from "components/ui/Loader/Loader";
import HTMLContainer from "components/ui/HTML/HTMLContainer";
import { Swiper, SwiperSlide } from "swiper/react";

function TipOfTheDay() {
  const swiperRef = useRef();
  const { view, isLoading } = useViewData('tip');

  let content;
  if (!isLoading) {
    content = view.map(row =>
      <SwiperSlide key={ row.id } className={ `daily-tip__slide` }>
        <HTMLContainer>{ row.body }</HTMLContainer>
      </SwiperSlide>);
  }

  return (
    <div className={ 'daily-tip' }>
      <div className={ 'daily-tip__title' }>
        <div className={ 'daily-tip__icon' }>
          <Icon/>
        </div>

        <span>Tip</span>
      </div>

      <div className={ 'daily-tip__divider' }>
        |
      </div>

      <div className={ 'daily-tip__content' }>
        {
          isLoading ? <Loader containerVariant={ 'center' } loaderVariant={ 'small' }/> :
            <Swiper
              ref={ swiperRef }
              initialSlide={ Math.floor(Math.random() * view.length) }
              slidesPerView={ 1 }
              spaceBetween={ 16 }
              loop={ true }
              resizeObserver={ false }
            >
              { content }
            </Swiper>
        }
      </div>

      <div className={ 'daily-tip__controls' }>
        <div className={ 'daily-tip__prev' } onClick={ () => swiperRef.current.swiper.slidePrev() }>
          <Arrow/>
        </div>

        <div className={ 'daily-tip__next' } onClick={ () => swiperRef.current.swiper.slideNext() }>
          <Arrow/>
        </div>
      </div>
    </div>
  );
}

export default TipOfTheDay;
